export const POST_SALES_CORPORATE = "POST_SALES_CORPORATE";
export const POST_SALES_APARTMENT = "POST_SALES_APARTMENT";
export const CAT_BY_PRODUCT = "CAT_BY_PRODUCT";
export const CAT_BY_BRAND = "CAT_BY_BRAND";
export const TAG = "TAG";
